import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { Typography } from "core/typography/Typography";

const DeliveryNotePreviewColumn = ({
  columnRef,
  showTitle = true,
  children,
}) => (
  <aside className="delivery-note-preview-column" ref={columnRef}>
    {showTitle && (
      <Typography
        className="title-3 violet text-uppercase"
        type="h2"
        label={
          <FormattedMessage
            id="delivery_note_preview"
            defaultMessage="Aperçu"
          />
        }
      />
    )}
    {children}
  </aside>
);

DeliveryNotePreviewColumn.propTypes = {
  columnRef: PropTypes.object,
  showTitle: PropTypes.bool,
  children: PropTypes.node,
};

export default DeliveryNotePreviewColumn;
